import React from "react";

export function UserRolesRoles() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-800">Roles</h2>
        <p className="text-sm text-muted-foreground">
          Roles management content will be added here.
        </p>
      </div>
    </div>
  );
}
